import React from "react"
import ReactGA from "react-ga4"

import Instagram  from "../1-lora/images/Instagram.svg"
import LinkedIn   from "../1-lora/images/LinkedIn.svg"
import Twitter    from "../1-lora/images/Twitter.svg"
import YouTube    from "../1-lora/images/YouTube.svg"

import RouterSide   from "../../containers/UI/RouterSide.png"
import RouterFront  from "../../containers/UI/RouterFront.png"
import Victoria     from "../../containers/UI/Victoria.png"
import FatArrow     from "../../containers/UI/FatArrow-orange.svg"
import Bridge       from "./images/Bridge.png"
import Layers       from "./images/Layers.png"

import intro    from "./css/1-introduction.css"
import bridged  from "./css/2-bridged.css"
import connect  from "./css/3-connect.css"
import hood     from "./css/4-hood.css"
import action   from "./css/5-action.css"
import foot     from "./css/6-footer.css"

const Gateway = () => {



  return (
    <>
      <div className={intro.container}>
        <p className={intro.introducing}>Introducing the world's first</p>
        <p className={intro.productName}>KNX IoT Router</p>
        <div className={intro.imageContainer}>
            <img className={intro.productImage} src={RouterSide} alt="Allorado KNX IoT Router from the side."/>
        </div>
        <p className={intro.tagline}>The future of KNX starts <span className={intro.tagAccent}>here.</span></p>
      </div>


      <div className={bridged.container}>

        <div className={bridged.leftContainer}>
          <img className={bridged.bridgeVisual} src={Bridge} alt="KNX IoT Router as bridge between IoT and classic."/>
        </div>

        <div className={bridged.rightContainer}>
          <label className={bridged.title}>Two worlds,<br/><span className={bridged.boldTitle}>bridged.</span></label>
          <div className={bridged.text}>
            KNX Classic has stood the test of time. KNX IoT is the future. The KNX IoT Router is the missing link — a seamless bridge that lets existing installations communicate with the new IoT ecosystem. 
          </div>
        </div>

      </div>

      <div className={connect.container}>
        <p className={connect.rewiring}>No rewiring.</p>
        <p className={connect.connecting}>Just connecting.</p>
        <div className={connect.imageContainer}>
            <img className={connect.productImage} src={Layers} alt="KNX IoT architecture on top of IPv6 and wireless protocols."/>
        </div>
        <p className={connect.text}>KNX IoT enables secure, low-power wireless solutions perfect for retrofits. Upgrading legacy buildings becomes a plug-and-play evolution — <br/>no cables, no construction, no compromise.</p>
      </div>

      <div className={hood.container}>
        <p className={hood.title}>Under the hood.</p>
        <div className={hood.gridContainer}>
          <div className={hood.leftContainer}>
            <div className={hood.tileContainer} style={{ flex: "5 1 50px", marginBottom: "20px", alignItems: "center" }}>
              <div className={hood.imageContainer}>
                <img className={hood.imageContainer} src={RouterFront} alt="KNX IoT Router from the front."/>
              </div>
              <div className={hood.specRow}>
                <label className={hood.specTitle}>Connectivity</label>
                <label className={hood.specBody}>1x Ethernet</label>
              </div>
              <div className={hood.specRow}>
                <label className={hood.specTitle}>Mounting</label>
                <label className={hood.specBody}>DIN rail</label>
              </div>
              <div className={hood.specRow}>
                <label className={hood.specTitle}>Input range</label>
                <label className={hood.specBody}>12 - 24 V</label>
              </div>
            </div>
            <div className={hood.tileContainer} style={{ flex: "1 1 50px", justifyContent: "center" }}>
              <label className={hood.awaiting}>Awaiting the opening of</label>
              <label className={hood.certification}>KNX IoT Router certification</label>
            </div>
          </div>
          <div className={hood.rightContainer}>
            <div className={hood.tileContainer} style={{ flex: "1 1 100px", marginBottom: "20px" }}>
              <label className={hood.tileTitle}>KNX Classic</label>
              <ul className={hood.bulletList}>
                <li>Integrates via <span>KNXnet/IP Routing</span></li>
                <li>Compatible with <span>KNX IP Secure</span></li>
                <li>Compatible with <span>KNX Data Secure</span></li>
              </ul>
            </div>
            <div className={hood.tileContainer} style={{ flex: "1 1 100px" }}>
              <label className={hood.tileTitle}>KNX IoT</label>
              <ul className={hood.bulletList}>
                <li>Built upon <span>IPv6</span></li>
                <li>Secure by design using <span>OSCORE</span></li>
                <li>Compliant with <span>KNX Point API</span> specifications</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className={action.container}>
         <div className={action.leftContainer}>
          <img src={Victoria} alt="Allorado Sales Manager Victoria Bohn"/>
        </div>
        <div className={action.rightContainer}>
          <label className={action.curious}>Curious?</label>
          <label className={action.letstalk}>Let's talk KNX IoT.</label>
          <div className={action.contactRow}>
            <button onClick={() => { ReactGA.event({ category: "Button", action: "Contact KNX IoT Router" }); window.location = "mailto:victoria@allorado.io?subject=Interested in KNX IoT Router" }}>Contact Victoria</button>
            <img src={FatArrow} className={action.arrow} alt="arrow"/>
          </div>
        </div>
      </div>

      <div className={foot.footerContainer}>
        <div className={foot.copyrightContainer}>
          <p className={foot.copyright}>Copyright © {new Date().getFullYear()} Allorado BV</p>
        </div>
        <div className={foot.socialContainer}>
          <img onClick={() => { ReactGA.event({ category: "Button", action: "LinkedIn" }); window.open("https://www.linkedin.com/company/allorado", "_blank") }} className={foot.socialIcon} src={LinkedIn} alt="LinkedIn logo"/>
          <img onClick={() => { ReactGA.event({ category: "Button", action: "YouTube" }); window.open("https://www.youtube.com/channel/UCAIq8RWLwBDIT_lyO8SBONA", "_blank") }} className={foot.socialIcon} src={YouTube} alt="YouTube logo"/>
          <img onClick={() => { ReactGA.event({ category: "Button", action: "Instagram" }); window.open("https://www.instagram.com/allorado.io", "_blank") }} className={foot.socialIcon} src={Instagram} alt="Instagram logo"/>
          <img onClick={() => { ReactGA.event({ category: "Button", action: "Twitter" }); window.open("https://twitter.com/allorado_io", "_blank") }} className={foot.socialIcon} src={Twitter} alt="Twitter logo"/>
        </div>
        <div style={{width: "250px"}}></div>
      </div>
    </>
  )
}

export default Gateway;
